import { render, staticRenderFns } from "./successTip.vue?vue&type=template&id=7057f6ab&scoped=true&"
import script from "./successTip.vue?vue&type=script&lang=js&"
export * from "./successTip.vue?vue&type=script&lang=js&"
import style0 from "./successTip.vue?vue&type=style&index=0&id=7057f6ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7057f6ab",
  null
  
)

export default component.exports